import ColumnTypes from '@/utils/ColumnTypes';

//团长信息
const tzInfo = {
	label: '团长信息',
	key: 'institution_name',
	type: () => import('./tzInfoCell.vue'),
	width: '200',
};
// 报名活动信息
const signActivityInfo = {
	label: '报名活动信息',
	key: 'signActivityInfo',
	type: () => import('./signCell.vue'),
	width: '200',
};
const activityServiceRate = {
	key: 'serviceRatio',
	label: '活动服务费率',
	type: ColumnTypes.TextCell,
	minWidth: '80',
};
const colonelActivitySquare = {
	key: 'colonelActivitySquare',
	label: '商品信息',
	minWidth: '300',
	type: () => import('./shopCell.vue'),
};
// 报名状态
const signUpStatus = {
	key: 'applyStatusDesc',
	label: '报名状态',
	type: ColumnTypes.TextCell,
	width: '120',
};

const promotionEndTime = {
	key: 'applyTime',
	label: '提报时间',
	type: ColumnTypes.TextCell,
	minWidth: '150',
};
// 操作人
const operator = {
	key: 'userName',
	label: '操作人',
	type: ColumnTypes.TextCell,
	minWidth: '120',
};

export const columns = [tzInfo, signActivityInfo, activityServiceRate, colonelActivitySquare, signUpStatus, promotionEndTime, operator];
